// extracted by mini-css-extract-plugin
module.exports = {"CovidPromise__body":"styles-module--CovidPromise__body--k8oXP"};